/**
 * Avatar Navigation Handler
 *
 * Routes avatar taps to the correct profile edit screen.
 * "Me" → /edit-profile, others → /family-member/[id]/edit.
 */

import type { Router } from 'expo-router';
import type { FamilyMemberResource } from '@/types/family-resource';

export class AvatarNavigationHandler {
  static navigateToProfile(router: Router, resource: FamilyMemberResource): void {
    if (resource.isMe) {
      router.push('/edit-profile');
    } else {
      router.push(`/family-member/${resource.id}/edit` as any);
    }
  }
}
